/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface EmailContentGroupRef
 */
export interface EmailContentGroupRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupRef
   */
  groupId?: number;
}

export interface EmailContentGroupRef extends EmailContentGroupRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupRef
   */
  groupId: number;
}

export interface EmailContentGroupRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupRef
   */
  groupId?: number;
  groupIdIsSet: boolean;
}

transformDatesMap.set(
  "EmailContentGroupRef",
  function (model: EmailContentGroupRef) {},
);

export type EmailContentGroupRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  groupId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var EmailContentGroupRefMeta: EmailContentGroupRefMetaI =
  {} as EmailContentGroupRefMetaI;
EmailContentGroupRefMeta = typeMeta("EmailContentGroupRef", {
  groupId: propertyMeta("groupId", false, true, true, MetaTypesBase.number),
});

const metaI = EmailContentGroupRefMeta;

registerMeta(() => {});

export class EmailContentGroupRefTracked implements EmailContentGroupRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  groupId__I?: number = undefined;

  get groupIdIsSet() {
    return this.groupId !== undefined;
  }
  set groupIdIsSet(v: boolean) {}
  set groupId(v: undefined | number) {
    if (v !== undefined) {
      this.groupId__I = v;
      this.groupIdIsSet = true;
    } else {
      this.groupId__I = v || undefined;
      this.groupIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get groupId() {
    return this.groupId__I;
  }
  constructor(config?: EmailContentGroupRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.groupIdIsSet == true && other?.groupIdIsSet == true)
      return this.groupId == other.groupId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.groupId) {
      this.groupIdIsSet = true;
    }
  }
  assignFrom(
    config: EmailContentGroupRefOptional,
    options?: AssignOptions,
  ): EmailContentGroupRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.groupId && this.groupIdApplyFilter(optionsRequired.filter)) {
      this.groupId = config.groupId;
      if (optionsRequired.unassign) this.groupIdIsSet = false;
      else this.groupIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailContentGroupRefTrackedI {
    const cloned = {} as EmailContentGroupRefTrackedI;
    if (
      this.groupIdIsSetDeep() &&
      this.groupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupIdIsSet = true;
      cloned.groupId = this.groupId;
    } else {
      //cloned.groupIdIsSet = false
    }
    if (!isDeleted(this) && !this.groupIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailContentGroupRefTrackedI {
    if (!this.groupIdApplyFilter(filter)) this.groupIdIsSet = false;

    return this;
  }
  groupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupRefMeta.groupId,
      EmailContentGroupRefMeta,
      this.groupId,
      this,
    );
  }
  groupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupIdIsSet && this.groupIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.groupIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
